<!-- <div class="dsb-card">
  <div class="dsb-card-header">
    <span>
      <span style="margin-right: 1em;" class="dsb-status-symbol">{{statusSymbol}}</span>
      <span class="dsb-status">{{statusDescription}}</span>
    </span>
    <span style="font-weight: bold;">{{dsbOccurrence.pmtReason}}</span>
  </div>

  <div class="dsb-card-subheader">{{dsbOccurrence.pmtDescription}}</div>

  <div class="dsb-card-content-container">
    <label class="dsb-card-label">AMOUNT</label>
    <span class="dsb-card-value">{{ dsbOccurrence.pmtAmt }}</span>

    <label class="dsb-card-label">EFFECTIVE DATE</label>
    <span class="dsb-card-value">{{ dsbOccurrence.pmtEffectiveDate }}</span>

    <label class="dsb-card-label">REFERENCE NUMBER</label>
    <span class="dsb-card-value">{{ dsbOccurrence.referenceNum ? dsbOccurrence.referenceNum : '' }}</span>

    <label class="dsb-card-label">ACCOUNT TYPE</label>
    <span class="dsb-card-value">{{ dsbOccurrence.payments.length != 0 ? dsbOccurrence.payments[0].accountType : '' }}</span>

    <label class="dsb-card-label">ACCOUNT NICKNAME</label>
    <span class="dsb-card-value">{{ dsbOccurrence.payments.length != 0 ? dsbOccurrence.payments[0].accountNickname : '' }}</span>
  </div>

  <div class="dsb-card-footer" *ngIf="dsbOccurrence.status == 'CREATED' || dsbOccurrence.status ==  'INVITED' || dsbOccurrence.status == 'FUNDING_SELECTED'">
    <button type="button" class="dsb-btn" (click)="onChooseFundingAccount(dsbOccurrence.disbursementOccurrenceUuid)">
      Choose Funding Account
    </button>

    <button type="button" class="dsb-btn" *ngIf="dsbOccurrence.status == 'FUNDING_SELECTED'" (click)="onDisburseFunds()">
      Disburse Funds
    </button>
  </div>
  <div>
    <select #fundingAccounts (change)="onSelected()">
      <option value="0">Select Funding method</option>
      <option value="1">Funding method #1</option>
      <option value="2">Funding method #2</option>
      <option value="3">Funding method #3</option>
    </select>
  </div>

</div> -->


<div class="dsb-card">
  <div class="dsb-card-header">
    <!-- <span style="color: #000;font-weight: bold;">Company Name</span> -->
    <span>
      <span style="margin-right: .4em;" class="dsb-status-symbol">{{statusSymbol}}</span>
      <span>{{statusDescription}}</span>
    </span>

    <span  style="color:green;font-weight: bold;">{{ dsbOccurrence.pmtAmt | currency:'USD':'symbol' }}</span>
  </div>

  <div class="small-dsb-card-item">{{dsbOccurrence.pmtDescription}}</div>
  <div class="small-dsb-card-item">Issued: {{ dsbOccurrence.issueDate }}</div>
  <div class="small-dsb-card-item">Ref #: {{ dsbOccurrence.referenceNum ? dsbOccurrence.referenceNum : '' }}</div>
  <div class="divider"></div>

  <!-- <div class="dsb-card-item">
    <span style="color: #000;font-weight: bold;">Distribute to: </span>
    <span>{{ dsbOccurrence.payments.length != 0 ? dsbOccurrence.payments[0].accountType : '' }}</span>
  </div> -->
    <!-- <span>Personal Checking</span>  -->

  <ng-container *ngIf="dsbOccurrence.disbursable">
  <div class="dsb-card-item">
    <span style="color: #000;font-weight: bold;">Distribute to: </span>
    <!-- <span>{{ dsbOccurrence.payments.length != 0 ? dsbOccurrence.payments[0].accountType : '' }}</span> -->
  </div>
  <select name="#fundingAccountsDropdown" id="fundingAccountsDropdown" [(ngModel)]="dsbOccurrence.fundingAccountToken"  (change)="onSelected()">
      <option [ngValue]="'0'">&lt;Select Funding Method&gt;</option>
      <option *ngFor="let fa of fundingAccounts" [ngValue]="fa.tokenid" >{{fa.fundingAccountNickname}}</option>
    </select>
  </ng-container>

  <ng-container *ngIf="!dsbOccurrence.disbursable">
    <div class="dsb-card-item">
      <span style="color: #000;font-weight: bold;">Distributed to: </span>
      <!-- <span>{{ dsbOccurrence.payments.length != 0 ? dsbOccurrence.payments[0].accountType : '' }}</span> -->
    </div>
    <div style="margin: 0.5em 0;">
      <span>{{selectedFundingAccountDescription}}</span>
    </div>
  </ng-container>

  <div class="button-wrapper">
    <button [disabled]="!dsbOccurrence.disbursable || dsbOccurrence.fundingAccountToken=='0'" (click)="onDisburseFunds()">Disburse Funds</button>
  </div>

  <div class="link-wrapper">
    <a href='/dsb-funding-accounts'>Manage Funding Methods</a>
    <!-- <a href='/dsb-funding-accounts' (click)="onChooseFundingAccount(dsbOccurrence.disbursementOccurrenceUuid)">Manage Funding Methods</a> -->
  </div>

  <div *ngIf="isDsbMessageShown" class="alert alert-warning alert-dismissible fade show" role="alert">
    {{dsbMessage}}
    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-lable="Close"></button>
  </div>  

</div>
